const calculateInitialPosition = (buttonRect, windowSize) => {
  if (!buttonRect || !windowSize) {
    return { x: 50, y: 50 };
  }

  return {
    x: Math.max(0, buttonRect.right - windowSize.width),
    y: Math.max(0, buttonRect.top - 60 - windowSize.height),
  };
};

const formatErrorForDisplay = (error, isDevelopment = false) => {
  if (!error) return null;

  return {
    title: 'Something went wrong',
    message: 'The Assistant encountered an unexpected error. Please try again.',
    details: isDevelopment ? error.toString() : null,
  };
};

export { calculateInitialPosition, formatErrorForDisplay };
